import { render } from "./AModal.vue?vue&type=template&id=13215a3c"
import script from "./AModal.vue?vue&type=script&lang=js"
export * from "./AModal.vue?vue&type=script&lang=js"

import "./AModal.vue?vue&type=style&index=0&id=13215a3c&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__